import React from "react";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";

const fallbackSections = [
  {
    _type: "heroAlternative",
    title: "Providing Solutions for your professional needs",
    description: "August Twenty Liberia operates at Horton House. Horton House provides a secure, generator-backed, professionally managed workspace designed for businesses. We are not just renting rooms — we are building a professional ecosystem and networking opportunities to build your brand.",
    image: "/HortonHouse.jpeg",
  },
  {
    _type: "gallery",
    title: "Book A Space",
    subtitle: "Find the perfect workspace for your needs",
    items: [
      { title: "Hot Desks", description: "Perfect for our independent workers and small teams in an open area. Book below.", image: "/hot-desks.jpeg" },
      { title: "Meeting Rooms", description: "Suitable for presentations and meetings with your team and clients. Book below.", image: "/IMG_1064.jpeg" },
      { title: "Conference Rooms", description: "Available for live presentations and meetings on a larger scale. Book below.", image: "/conference.jpeg" },
      { title: "Virtual Space", description: "Establish a professional presence without the cost of a physical workspace. Book below.", image: "/VirtualSpace.jpg" },
      { title: "Office Rental", description: "Perfect for established businesses needing privacy. Book below.", image: "/office-rental.jpeg" },
      { title: "Suite Rental", description: "Professional private office suites designed to give your business a secure and flexible base. Book below.", image: "/suite.jpeg" },
    ],
  },
  { _type: "bookSpaceForm", title: "Book a Space" },
  {
    _type: "faqAccordion",
    eyebrow: "FAQ",
    title: "Answers To Your Most Common Questions",
    items: [
      { question: "What amenities are included in meeting rooms?", answer: "We can provide WiFi, whiteboards, a projector, a conference speaker, and printing facilities. See Terms and Conditions." },
      { question: "What amenities are included in Hot Desks?", answer: "Our hot desk options range from working booths to tables with desk dividers. Each space includes access to power outlets for your devices and use of our shared kitchen." },
      { question: "What are your opening hours and are they flexible for functions?", answer: "We can be flexible; however, our standard openings are as follows: Monday to Friday 9am to 5pm. Weekends by special appointment only." },
      { question: "Is there any trial period available for any of the spaces?", answer: "No, we do not offer trial periods for any of the spaces. We do guided tours!" },
    ],
  },
];

export default function HortonHouse() {
  const { data } = useSanityContent(PAGE_QUERY("horton-house"), { sections: fallbackSections });
  return <PageBuilder sections={data.sections} />;
}
